var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DropdownSelect, SelectItem } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import uniq from 'lodash/uniq';
import { PureComponent } from 'react';
import bulkActionActions from 'components/bulkActions/actions/bulkActions';
import { BulkActionTypeMap, getBulkActionById, } from 'components/bulkActions/api/bulkActions';
import { createStartBulkNotificationAction } from 'components/bulkActions/sagas/bulkActions';
import { notificationActions } from 'components/notifications/actions/notification';
import { getRequestID } from 'components/shared/util/request';
import { conversationsOverviewActions } from '../../../conversationsOverview/actions/conversationsOverview';
import styles from './failedBulkActions.module.scss';
const { conversationsOverviewFetchBulkIds } = conversationsOverviewActions;
export class FailedBulkActions extends PureComponent {
    getAllConversationIDs(bulkId) {
        return new Promise((resolve, reject) => {
            getBulkActionById(bulkId)
                .then((bulkActionData) => {
                resolve(uniq(bulkActionData.data.conversation_ids));
            })
                .catch(reject);
        });
    }
    getFailedConversationIDs(bulkId) {
        const { getFailedBulkActions } = this.props;
        return new Promise((resolve, reject) => {
            getFailedBulkActions(bulkId)
                .then((failedBulkAction) => {
                const failedConversationIDs = failedBulkAction.map((failedAction) => failedAction.conversationId);
                resolve(uniq(failedConversationIDs));
            })
                .catch(reject);
        });
    }
    getSucceededConversationIDs(bulkId) {
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getAllConversationIDs(bulkId),
                this.getFailedConversationIDs(bulkId),
            ]).then(([allIDs, failedIDs]) => {
                const successIDs = allIDs.filter((id) => failedIDs.indexOf(id) === -1);
                resolve(uniq(successIDs));
            });
        });
    }
    retryFailedAction() {
        const { notification, getFailedBulkActions, dispatch } = this.props;
        const bulkID = notification.bulkId;
        getFailedBulkActions(bulkID)
            .then((failedBulkAction) => {
            const failedConversationIDs = failedBulkAction.map((failedAction) => failedAction.conversationId);
            if (!failedConversationIDs.length)
                return;
            getBulkActionById(bulkID).then((bulkRes) => {
                try {
                    const bulkType = BulkActionTypeMap[bulkRes.data.action_type] || null;
                    const requestInput = JSON.parse(bulkRes.data.request_input);
                    const id = getRequestID();
                    if (bulkType && requestInput) {
                        dispatch(createStartBulkNotificationAction(id, notification.data.title, failedConversationIDs, (dispatch) => {
                            dispatch(notificationActions.notificationRemoveAllById({ id }));
                            dispatch({
                                type: bulkActionActions.bulkActionsCallApi.toString(),
                                payload: {
                                    bulkType,
                                    data: Object.assign({ csids: failedConversationIDs }, requestInput),
                                },
                            });
                        }));
                    }
                }
                catch (error) {
                    console.warn(error);
                }
            });
        })
            .catch((err) => {
            console.error(err);
        });
    }
    getDropdownItems() {
        const { bulkStatus } = this.props;
        const items = [];
        if (bulkStatus !== 'BulkActionFailed') {
            items.push({
                id: 'all',
                name: 'Update all conversations',
            });
        }
        if (bulkStatus === 'BulkActionFailed' ||
            bulkStatus === 'BulkActionPartialFailed') {
            items.push({
                id: 'failed',
                name: 'Update failed conversations',
            });
        }
        if (bulkStatus === 'BulkActionPartialFailed') {
            items.push({
                id: 'succeeded',
                name: 'Update succeeded conversations',
            });
        }
        return items;
    }
    getIDGetterFunction(action) {
        if (action.id === 'all') {
            return this.getAllConversationIDs;
        }
        if (action.id === 'succeeded') {
            return this.getSucceededConversationIDs;
        }
        return this.getFailedConversationIDs;
    }
    selectAction(action) {
        const { notification, dispatch } = this.props;
        const getter = this.getIDGetterFunction(action);
        getter(notification.bulkId)
            .then((conversationIDs) => {
            // Fetch validation rules for conversationIDs
            dispatch(conversationsOverviewFetchBulkIds({
                csids: conversationIDs,
            }));
            return conversationIDs;
        })
            .then((conversationIDs) => {
            dispatch(bulkActionActions.bulkActionsOpenModal({
                conversationIDs,
            }));
        });
    }
    render() {
        const { bulkStatus } = this.props;
        return (_jsxs("div", Object.assign({ className: styles.root }, { children: [(bulkStatus === 'BulkActionFailed' ||
                    bulkStatus === 'BulkActionPartialFailed') && (_jsx(Button, Object.assign({ className: styles.action, variant: "secondary", onClick: this.retryFailedAction }, { children: "Retry" }))), _jsx(DropdownSelect, Object.assign({ className: styles.action, items: this.getDropdownItems(), itemComponent: SelectItem, noArrow: false, onSelect: this.selectAction }, { children: "Add action" }))] })));
    }
}
__decorate([
    boundMethod
], FailedBulkActions.prototype, "getFailedConversationIDs", null);
__decorate([
    boundMethod
], FailedBulkActions.prototype, "getSucceededConversationIDs", null);
__decorate([
    boundMethod
], FailedBulkActions.prototype, "retryFailedAction", null);
__decorate([
    boundMethod
], FailedBulkActions.prototype, "getDropdownItems", null);
__decorate([
    boundMethod
], FailedBulkActions.prototype, "selectAction", null);
